"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccordionMixin = void 0;
var _styledComponents = require("styled-components");
var _listResetMixin = require("../listResetMixin");
var _marginMixin = require("../marginMixin");
/** @class AccordionMixin */
/** @method */
var AccordionMixin = function AccordionMixin(props) {
  return (0, _styledComponents.css)(["", " ", ""], _listResetMixin.listResetMixin, (0, _marginMixin.marginMixin)(Object.assign({}, props)));
};
exports.AccordionMixin = AccordionMixin;